import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['text', 'time']
  static outlets = ['daily-tracking--meals--global-fields']

  addInput() {
    this.textTarget.value =
      this.dailyTrackingMealsGlobalFieldsOutlet.foodTarget.value

    if (this.dailyTrackingMealsGlobalFieldsOutlet.customTimeSelectorTarget.checked) {
      this.timeTarget.value =
        this.dailyTrackingMealsGlobalFieldsOutlet.timeTarget.value
    }
  }
}
